import React, { useEffect, useRef } from 'react';
import { MailIcon, LinkedinIcon, MapPinIcon, YoutubeIcon } from 'lucide-react';
export function ContactContent() {
  const schedulerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    let frame = 0;
    const scrollToScheduler = () => {
      if (window.location.hash !== '#/contact/book') return;
      frame = requestAnimationFrame(() => {
        schedulerRef.current?.scrollIntoView({
          block: 'start'
        });
      });
    };
    scrollToScheduler();
    window.addEventListener('hashchange', scrollToScheduler);
    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener('hashchange', scrollToScheduler);
    };
  }, []);
  return <section className="w-full bg-white pt-16 md:pt-20 pb-12 md:pb-14 px-4 sm:px-6 lg:px-8" data-id="element-6" data-mp="2gw1nh450kfju">
      <div className="max-w-4xl mx-auto" data-id="element-7" data-mp="2bw6vex9i5jx7">
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-brand-navy mb-10 leading-tight" data-id="element-8" data-mp="2bv5bs4ef7p3v">
          Let's talk.
        </h1>
        <p className="text-2xl md:text-3xl text-brand-gray leading-relaxed mb-12" data-id="element-9" data-mp="27x7ley8wywyw">
          Whether you have a specific need or just want to explore how AI
          transformation could work for your team, I'd love to hear from you.
        </p>

        <div className="space-y-16" data-id="element-10" data-mp="1jl3fmzze82l0">
          {/* Book a Call */}
          <div id="book" ref={schedulerRef} className="scroll-mt-28" data-id="element-11" data-mp="1oivdsbqmskxn">
            <div className="w-full rounded-lg border border-gray-200 bg-white shadow-md overflow-hidden" data-id="element-12" data-mp="1oh23mmgt7ikw">
              <iframe src="https://scheduler.zoom.us/breakapencil/intro-call-30?embedStyle=%7B%22textColor%22%3A%22%231a1448%22%2C%22buttonColor%22%3A%22%23ed7731%22%7D&origin=breakapencil.com&embed=true" title="Schedule a 30-minute intro call" className="w-full h-[560px] border-0 block" data-id="element-13" data-mp="2c6wkrg85vtay" />
            </div>
          </div>

          {/* Email */}
          <div className="flex items-start py-8 border-b border-gray-100" data-id="element-14" data-mp="vuhdfpc2lcix">
            <MailIcon className="w-8 h-8 text-brand-orange mr-6 mt-1 flex-shrink-0" data-id="element-15" data-mp="vsd3oqrhpjaq" />
            <div data-id="element-16" data-mp="2ygd0iqtehkkc">
              <h2 className="text-2xl font-bold text-brand-navy mb-4" data-id="element-17" data-mp="2yiz8uso4843m">Email</h2>
              <a href="mailto:michael@breakapencil.com" className="text-xl text-brand-gray-light hover:text-brand-orange transition-colors border-b-2 border-brand-orange/30 hover:border-brand-orange pb-1" data-id="element-18" data-mp="2titn1t4j1btg">
                michael@breakapencil.com
              </a>
            </div>
          </div>

          {/* Connect */}
          <div className="flex items-start py-8 border-b border-gray-100" data-id="element-19" data-mp="2aqiogbgwo015">
            <LinkedinIcon className="w-8 h-8 text-brand-orange mr-6 mt-1 flex-shrink-0" data-id="element-20" data-mp="25rxng9ttxcbn" />
            <div data-id="element-21" data-mp="20tmd7xzmgzsw">
              <h2 className="text-2xl font-bold text-brand-navy mb-4" data-id="element-22" data-mp="20u5xvmgnq2am">
                Connect
              </h2>
              <div className="flex flex-col sm:flex-row sm:items-center gap-6" data-id="element-23" data-mp="401b4xzu7yft">
                <a href="https://www.linkedin.com/in/mhirsch/" target="_blank" rel="noopener noreferrer" className="text-xl text-brand-gray-light hover:text-brand-orange transition-colors inline-flex items-center" data-id="element-24" data-mp="3v75jbw7pxqpt">
                  <LinkedinIcon className="w-6 h-6 mr-3" data-id="element-25" data-mp="gb258l4tj8n3" />
                  LinkedIn
                </a>
                <a href="https://www.youtube.com/@Break-a-Pencil" target="_blank" rel="noopener noreferrer" className="text-xl text-brand-gray-light hover:text-brand-orange transition-colors inline-flex items-center" data-id="element-26" data-mp="l9ddirfgtb37">
                  <YoutubeIcon className="w-6 h-6 mr-3" data-id="element-27" data-mp="3tpgmd0ibd5t4" />
                  YouTube
                </a>
              </div>
            </div>
          </div>

          {/* Location */}
          <div className="flex items-start py-8" data-id="element-28" data-mp="190sjcu6gaaj7">
            <MapPinIcon className="w-8 h-8 text-brand-orange mr-6 mt-1 flex-shrink-0" data-id="element-29" data-mp="1923niv3t5kau" />
            <div data-id="element-30" data-mp="1dx9a7w51b2zz">
              <h2 className="text-2xl font-bold text-brand-navy mb-4" data-id="element-31" data-mp="1e0x5azq4nxgt">
                Location
              </h2>
              <p className="text-xl text-brand-gray-light" data-id="element-32" data-mp="2hx7j6v9benuu">
                Seattle, Washington. Working with teams everywhere.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}